// 详情模块

const Detail = {
  namespaced: true,

  state: {
    dataList: [], // 多个页面复用，不分迁移了，有问题先从看清来源 data中也有dataList, 后期在做整体迁移
    reviewFromHistory: false,
    thumbInputFocus: false, // 反馈区textarea是否聚焦
    initStatus: true, // 用户进入页面
    end: false,
    anonymousId: '' // 神策的匿名Id
  },
  mutations: {
    SET_ANONYMOUS_ID: (state, anonymousId) => {
      state.anonymousId = anonymousId
    },
    SET_DATA_LIST: (state, dataList) => {
      state.dataList = dataList
    },
    SET_REVIEW_FROM_HISTORY: (state, reviewFromHistory) => {
      state.reviewFromHistory = reviewFromHistory
    },
    SET_THUMBINPUTFOCUS_STATUS: (state, thumbInputFocus) => {
      state.thumbInputFocus = thumbInputFocus
    },
    SET_INIT_STATUS: (state, initStatus) => {
      state.initStatus = initStatus
    }
  },
  getters: {
    isSensitiveStatus(state) {
      return state.dataList.some(data => data.is_sensitive)
    },
    isForbiddenStatus(state) {
      return state.dataList.some(data => data.forbidden)
    }
  },
  actions: {}
}

export default Detail
